const baseUrl = {
  // apiDevuelvoya: 'http://127.0.0.1:8000/',
  apiDevuelvoya: process.env.VUE_APP_API,
  // apiDevuelvoya: process.env.VUE_APP_API_NETWORK,

};

export default baseUrl;
